import { useEffect } from 'react';
import { useAppSelector } from 'store/hook';
import { selectHasUnsavedChanges } from 'store/site-config.slice';

export const useSiteConfigUnsavedGuard = () => {
  const hasUnsavedChanges = useAppSelector(selectHasUnsavedChanges);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
};
